import React from "react";

const CurrentAffairs = () => {
  return (
    <div className="container mt-5">
      <h2>📜 CurrentAffairs of India & National Movement</h2>
      <p>Detailed syllabus, notes, PYQs, and analysis will be here.</p>
    </div>
  );
};

export default CurrentAffairs;